// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__cGIW7","rootSuccess":"CompleteLink_rootSuccess__25Ad_","rootFailure":"CompleteLink_rootFailure__wwQ_n","isDisabled":"CompleteLink_isDisabled__1nSM-"};